import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import notificationsInitialState from '../initialState/notification'

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: notificationsInitialState,
  reducers: {
    setNotificationConnectionStatus(state, action: PayloadAction<boolean>) {
      state.isConnected = action.payload
    },
    setNotificationWebSocketError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },

    addNotification(state, action) {
      state.notifications = [
        action.payload.notification,
        ...state.notifications,
      ]
      if (action.payload.shouldIncrementUnread) {
        state.unreadCount++
      }
    },
    setInitialNotifications(state, action) {
      state.notifications = action.payload.notifications
      state.unreadCount = action.payload.unreadCount
    },
    setUnreadCount(state, action) {
      state.unreadCount = action.payload
    },

    // Mark a specific notification as read locally (before WebSocket confirms)
    updateNotificationReadStatus: (state, action: PayloadAction<number>) => {
      const notification = state.notifications.find(
        (n) => n.id === action.payload
      )
      if (notification && !notification.is_read) {
        notification.is_read = true
        state.unreadCount = Math.max(0, state.unreadCount - 1)
      }
    },

    // Reset notification state
    resetNotifications: (state) => {
      state.notifications = []
      state.unreadCount = 0
      state.isConnected = false
      state.loading = false
      state.error = null
    },
  },
})

export const {
  addNotification,
  updateNotificationReadStatus,
  resetNotifications,
  setNotificationConnectionStatus,
  setNotificationWebSocketError,
  setUnreadCount,
  setInitialNotifications,
} = notificationsSlice.actions

export default notificationsSlice.reducer
